import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { Section } from '@hub-la/fe-post'
import { useQuery } from '@tanstack/react-query'
import { GetSectionsInput } from '../../../../domain/dtos/member-area/settings/get-sections-input'
import { GetSections } from '../../../../usecases/member-area/settings/get-sections'

export const useGetSections = (input: GetSectionsInput) => {
  const container = useContainer()

  return useQuery<Section[], Error, Section[]>(
    ['get-sections', input.productId],
    () => new GetSections(container.get(HttpClient)).execute(input),
    {
      retryOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!input.productId,
    },
  )
}
